import ApiGateway from "./ApiGateway";
import { endpoints } from "../../site/configuration/endpoints";
import { BasketDetail } from "../types/Basket/BasketDetail";

import { OfferRequestDTO } from "../types/OrderOffer/Offer";
import { OrderFromOfferRequestDTO, OrderRequestDTO } from "../types/OrderOffer/Order";

export class OrderOfferService {
    public sendOffer = (
        brand: string,
        offer: OfferRequestDTO
    ): Promise<any> => {
        return new Promise<any>((resolve, reject) => {
            ApiGateway()
                .post<any>(
                    endpoints.orderoffer.sendOffer.replace("{brand}", brand),
                    offer
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };

    public sendOrder = (
        brand: string,
        order: OrderRequestDTO
    ): Promise<any> => {
        return new Promise<any>((resolve, reject) => {
            ApiGateway()
                .post<any>(
                    endpoints.orderoffer.sendOrder.replace("{brand}", brand),
                    order
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };

    public sendOrderFromOffer = (
        brand: string,
        order: OrderFromOfferRequestDTO
    ): Promise<any> => {
        return new Promise<any>((resolve, reject) => {
            ApiGateway()
                .post<any>(
                    endpoints.orderoffer.sendOrderFromOffer.replace(
                        "{brand}",
                        brand
                    ),
                    order
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };
}
